import styled from "styled-components";

export const ViewGenericAccountMainContainer = styled.div``;
